import Container from "../components/Container";

import media1 from "../assets/range_me.jpg";
import media2 from "../assets/GM_Today_article.jpg";

export default function Media() {
  const mediaFeatures = [
    {
      title: "Mass Market Retailers",
      link: "https://massmarketretailers.com/rangeme-top-brands-food-beverage-3/",
      image: media1,
    },
    {
      title: "GM Today",
      link: "https://www.gmtoday.com/news_graphic/business/teddys-tallow-chips-story/article_8377f29e-c01a-593d-aaca-c460d40d1c00.html",
      image: media2,
    },
  ];

  return (
    <section
      id="media"
      className="bg-brand-light min-h-screen md:h-screen flex items-center py-20 md:py-0"
    >
      <Container>
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-5xl sm:text-6xl md:text-6xl lg:text-7xl font-extrabold mb-8">
            In the Media
          </h2>

          <p className="text-xl sm:text-2xl md:text-2xl lg:text-3xl text-gray-700 mb-16 max-w-4xl mx-auto">
            Teddy’s Tallow has been featured by independent food and wellness
            publications and trusted by thousands of customers nationwide.
          </p>

          {/* Media Cards Grid */}
          <div className="grid md:grid-cols-2 gap-10">
            {mediaFeatures.map((media, index) => (
              <a
                key={index}
                href={media.link}
                target="_blank"
                rel="noopener noreferrer"
                className="
                  group
                  bg-white
                  rounded-3xl
                  shadow-sm
                  hover:shadow-lg
                  transition
                  px-12 py-16
                  flex flex-col items-center justify-center
                  text-center
                "
              >
                {media.image && (
                  <img
                    src={media.image}
                    alt={media.title}
                    className="w-40 sm:w-48 md:w-52 object-contain mb-8"
                  />
                )}

                <h3 className="text-2xl sm:text-3xl md:text-3xl font-semibold">
                  {media.title}
                </h3>

                <span className="mt-6 text-sm font-medium underline opacity-70 group-hover:opacity-100 transition">
                  Read feature →
                </span>
              </a>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
